import { useEffect, useRef, useState } from "react";
import jwt_decode from "jwt-decode";
import { NumberFormatMoney } from "../useForm";
import format from 'format-number'
import { Alert, Autocomplete, Box, Button, Collapse, Grid, IconButton, InputAdornment, Link, TextField } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import PreviewTwoToneIcon from '@mui/icons-material/PreviewTwoTone';

//import NumberFormat from "react-number-format";

export default function ValeDefinitivo(props) {
    const fileReporte = useRef(null);
    const fileOficio = useRef(null);
    const token = sessionStorage.getItem('token')
    const decoded = jwt_decode(token);
    const idResponsable = decoded.id;
    const [anio, setAnio] = useState(null)
    const [valeDefinitivo, setValeDefinitivo] = useState({
        monto: null,
        documentos: new FormData(), rutaOficio: null, rutaReporte: null, idEmpleado: null,
        idAlumno: props.matricula, beneficiario: { id: props.matricula },
        idPartidaProyecto: null, idSolicitud: null, observaciones: null, justificacion: null
    })
    const [proyectos, setProyectos] = useState([])
    const [proyecto, setProyecto] = useState(null)
    const [fechas, setFechas] = useState(null)
    const [partidasProyecto, setPartidasProyecto] = useState([])
    const [partida, setPartida] = useState(null);
    const [severity, setSeverity] = useState('error')
    const [idBeneficiario, setIdBeneficiario] = useState(props.matricula)

    const [sinConfiguracionFechas, setSinConfiguracionFechas] = useState(false)
    const [errorMonto, setErrorMonto] = useState(false)
    const [helperTextMonto, setHelperTextMonto] = useState('')
    const [errorBeneficiario, setErrorBeneficiario] = useState(false)
    const [helperTextBeneficiario, setHelperTextBeneficiario] = useState('')
    const [errorProyectoSinPartidas, setErrorProyectoSinPartidas] = useState(false)
    const [helperTextProyectoSinPartidas, setHelperTextProyectoSinPartidas] = useState('')
    const [errorOficio, setErrorOficio] = useState(false)
    const [helperTextOficio, setHelperTextOficio] = useState('')
    const [errorReporte, setErrorReporte] = useState(false)
    const [helperReporte, setHelperReporte] = useState('')
    const [openMensaje, setOpenMensaje] = useState(false);
    const [mensaje, setMensaje] = useState('');
    const [montoComprometido, setMontoComprometido] = useState(0);
    const [loading, setLoading] = useState(false)
    const [rutaOficio, setRutaOficio] = useState(false)
    const [rutaReporte, setRutaReporte] = useState(false)
    const idInforme = props.idInforme
    const idOficio = props.idOficio
    const idConcepto = props.idConcepto

    const seEnviaCorreo = props.seEnviaCorreo

    const mostrarDocumento = async (value, tipo) => {
        //console.log(`value en desplegarDocumentoPDF ${value}`)
        await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/servicios/mostrarFactura`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil'),
                "ruta": value,
                "tipo": tipo
            }
        }
        ).then((res) => res.blob())
            .then((blob) => { // RETRIEVE THE BLOB AND CREATE LOCAL URL
                var _url = window.URL.createObjectURL(blob);
                window.open(_url, "_blank").focus(); // window.open + focus
            }).catch((err) => {
                console.error(err);
            });
    }

    const leerProyectos = async () => {
        const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/informeProyecto/proyectos/${idResponsable}/${false}/${sessionStorage.getItem('idEntidad')}`, { //Siempre es gestión por eso se pone false
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            }
        })
        if (res.status === 404) {
            //console.log('regresó 404 en ValeDefinitivo') poner mensaje de error
            return
        }
        else {
            //console.log('si hay proyectos')
            const data = await res.json()
            //console.log(data)

            setProyectos(data)

            const idPlan = data[0].idPlan
            //console.log(`IDPLAN ${data[0].idPlan}`)
            const resPlan = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/planeacion/${idPlan}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": sessionStorage.getItem('token'),
                    "perfil": sessionStorage.getItem('perfil')
                }
            }
            )
            const plan = await resPlan.json()
            //console.log(`ANIO ${plan.anio}`)
            setAnio(plan.anio)
            await cargarFechas(plan.anio)
            //console.log(`ANIO ${plan.anio}`)
        }

    }

    const { idSolicitud, setIdSolicitud, verificarDisponible } = props;

    useEffect(() => {

        (async () => {
            await leerProyectos();
            //Pendiente la actualización
            if (idSolicitud) {
                const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/valeDefinitivo/${idSolicitud}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": sessionStorage.getItem('token'),
                        "perfil": sessionStorage.getItem('perfil')
                    }
                })
                const valeDefinitivo = await res.json()
                setMontoComprometido(valeDefinitivo.monto)
                setValeDefinitivo({ ...valeDefinitivo, documentos: new FormData() })
                setHelperTextBeneficiario(valeDefinitivo.beneficiario.nombreCompleto)
                setIdBeneficiario(valeDefinitivo.beneficiario.id)
                const resPartida = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/partidasProyecto/${valeDefinitivo.idPartidaProyecto}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": sessionStorage.getItem('token'),
                        "perfil": sessionStorage.getItem('perfil')
                    }
                })
                const partida = await resPartida.json()
                setPartida(partida)

                const resProyecto = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/proyectosPlan/proyecto/${partida.idProyectoPlan}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": sessionStorage.getItem('token'),
                        "perfil": sessionStorage.getItem('perfil')
                    }
                })
                const proyecto = await resProyecto.json()
                setProyecto(proyecto)
                const resPartidasProyecto = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/partidasProyecto/proyecto/${proyecto.id}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": sessionStorage.getItem('token'),
                        "perfil": sessionStorage.getItem('perfil')
                    }
                })

                const partidasProyectoLeidas = await resPartidasProyecto.json()
                const partidasProyectoLectura = partidasProyectoLeidas.filter(partidasProyectoLeidas => Number(partidasProyectoLeidas.clave) < 5000000 || Number(partidasProyectoLeidas.clave) > 5999999)
                //Mostrar sólo las no 5000
                //console.log(`transferenciasDestino.clave ${JSON.stringify(transferenciasDestino[0].partida.clave)}`)

                if (partidasProyectoLectura && partidasProyectoLectura.length > 0) {
                    setErrorProyectoSinPartidas(false)
                    setHelperTextProyectoSinPartidas('')
                    setPartidasProyecto(partidasProyectoLectura)
                }
                else {
                    setErrorProyectoSinPartidas(true)
                    setHelperTextProyectoSinPartidas('Este proyecto no tiene partidas')
                }
            }
            else {
                if (props.matricula) {
                    const resAlumno = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/alumnos/${props.matricula}`)
                    if (resAlumno.status === 404) {
                        setErrorBeneficiario(true)
                        setHelperTextBeneficiario('No hay ninguna persona registrada como Alumnado o Personal con esa matrícula o número económico')
                        return
                    }
                    else {
                        const beneficiario = await resAlumno.json()
                        valeDefinitivo.idAlumno = beneficiario.id
                        setErrorBeneficiario(false)
                        setHelperTextBeneficiario(beneficiario.nombreCompleto)
                        valeDefinitivo.beneficiario = { ...beneficiario }
                    }



                }
            }
            //await handleCarga()
        })();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {

        (async () => {
            if (partida) {
                await handleCarga();
            }
        })();
        // eslint-disable-next-line
    }, [partida]);

    const handleCarga = async () => {
        if (idInforme && fileReporte.current) {

            /* await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT_MONITORES}/utils/leerInforme/${idInforme}`, {
                 method: "GET",
                 headers: {
                     "Content-Type": "application/json",
                     "x-access-token": sessionStorage.getItem('token'),
                     "perfil": sessionStorage.getItem('perfil')
                 }
             }).then(response => response.blob())
             .then(blob => {
                 const file = new File([blob], `${tipoDocumento}_${idBeneficiario}.pdf`, { type: "application/pdf" });
                 console.log(file.name)
                 // Usar DataTransfer para simular la carga del archivo
                 //const dataTransfer = new FormData();
                 valeDefinitivo.documentos.append('reporte', file)
                 //dataTransfer.items.add(file);
                 
             })
             .catch(error => console.error('Error al cargar el archivo:', error));*/

            const resInforme = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT_MONITORES}/utils/leerDocumentoInforme/${idInforme}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": sessionStorage.getItem('token'),
                    "perfil": sessionStorage.getItem('perfil')
                }
            })

            const documentoInforme = await resInforme.json()
            valeDefinitivo.rutaReporte = documentoInforme.ruta
            //console.log(`valeDefinitivo.rutaReporte ${valeDefinitivo.rutaReporte}`)
            setRutaReporte(documentoInforme.ruta)
            setHelperReporte(<span><Link href={`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT_MONITORES}/utils/mostrarDocumento/${documentoInforme.id}`} target='_blank'>Reporte de actividades</Link>
            </span>)

        }
        if (idOficio && fileOficio.current) {
            const resOficio = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT_MONITORES}/utils/leerDocumentoOficio/${idOficio}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": sessionStorage.getItem('token'),
                    "perfil": sessionStorage.getItem('perfil')
                }
            })

            const documentoOficio = await resOficio.json()
            valeDefinitivo.rutaOficio = documentoOficio.ruta
            setRutaOficio(documentoOficio.ruta)
            //console.log(`valeDefinitivo.rutaOficio ${valeDefinitivo.rutaOficio}`)
            setHelperTextOficio(<span><Link href={`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT_MONITORES}/utils/mostrarDocumento/${documentoOficio.id}`} target='_blank'>Oficio CSA</Link>
            </span>)

        }
        if (idConcepto) {
            valeDefinitivo.idConcepto = idConcepto
        }
    }
    const cargarFechas = async (anio) => {

        //console.log(`ENTIDAD ${sessionStorage.getItem('idEntidad')}`)

        const entidad = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/entidad/${sessionStorage.getItem('idEntidad')}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            }
        })
        const entidadLeida = await entidad.json()

        const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/configuracionFechas/configuracion/${anio}/${entidadLeida.idEntidadSuperior ? entidadLeida.idEntidadSuperior : entidadLeida.id}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            }
        })
        const fechasLeidas = await res.json()
        if (res.status === 404) {
            setMensaje('Aún no se ha establecido la configuración de fechas, solicite a la Asistencia Administrativa que la registre')
            setOpenMensaje(true)
            setSinConfiguracionFechas(true)
        }
        //console.log(`FECHAS LEIDAS ${fechasLeidas.activarMontosPrioridad2}`)
        setFechas(fechasLeidas)
        const fechaCierreAdquisiciones = new Date(fechasLeidas.cierreAdquisiciones)
        fechaCierreAdquisiciones.setDate(fechaCierreAdquisiciones.getDate() + 1);
    }

    const colocarNombre = (ruta) => {
        if (!ruta || ruta === '')
            return ''
        const indice = Number(ruta.indexOf("documentosSolicitud")) + 20
        return ruta.slice(indice)

    }

    const handleUpdate = async (e) => {
        e.preventDefault()
        setLoading(true)
        valeDefinitivo.idPartidaProyecto = partida.idPartidaProyecto
        if (!rutaOficio) {
            if (valeDefinitivo.documentos.get('oficio')) {
                const oficio = new FormData();
                oficio.append('documento', valeDefinitivo.documentos.get('oficio'));
                const resUploadOficio = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/uploadDocumentoSolicitud`, {
                    method: "POST",
                    body: oficio
                })
                const ruta = (await resUploadOficio.json()).ruta
                valeDefinitivo.rutaOficio = ruta
                //console.log(`ruta ${ruta}`)
            }
        }
        if (!rutaReporte) {
            if (valeDefinitivo.documentos.get('reporte')) {
                const reporte = new FormData();
                reporte.append('documento', valeDefinitivo.documentos.get('reporte'));
                const resUploadReporte = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/uploadDocumentoSolicitud`, {
                    method: "POST",
                    body: reporte
                })

                const rutaReporte = (await resUploadReporte.json()).ruta
                valeDefinitivo.rutaReporte = rutaReporte
                //console.log(`rutaReporte ${rutaReporte}`)
            }
        }

        const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/valeDefinitivo/${valeDefinitivo.id}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            },
            body: JSON.stringify({
                idSolicitante: idResponsable,
                anio,
                valeDefinitivo,
                idProyecto: proyecto.id,
                claveProyecto: proyecto.clave,
                descripcionProyecto: proyecto.descripcion,
                partida,
                seEnviaCorreo
            })
        })

        if (res.status === 200)
            setSeverity('success')
        else
            setSeverity('error')

        const data = await res.json()

        if (data.message) {
            setOpenMensaje(true)
            setMensaje(data.message)
            setLoading(false)
            return
        }
        else {
            setOpenMensaje(true)
            setMensaje("Se actualizó la solicitud.")
            setLoading(false)
        }

    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        setLoading(true)
        //console.log(`valeDefinitivo.rutaOficio en handle submit ${valeDefinitivo.rutaOficio}`)
        if (!valeDefinitivo.rutaOficio) {
            const oficio = new FormData();
            oficio.append('documento', valeDefinitivo.documentos.get('oficio'));
            const resUploadOficio = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/uploadDocumentoSolicitud`, {
                method: "POST",
                body: oficio
            })
            const rutaOficio = (await resUploadOficio.json()).ruta
            valeDefinitivo.rutaOficio = rutaOficio
        }
        if (!valeDefinitivo.rutaReporte) {
            const reporte = new FormData();
            reporte.append('documento', valeDefinitivo.documentos.get('reporte'));
            const resUploadReporte = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/uploadDocumentoSolicitud`, {
                method: "POST",
                body: reporte
            })
            const rutaReporte = (await resUploadReporte.json()).ruta
            valeDefinitivo.rutaReporte = rutaReporte
        }

        const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/servicios/valeDefinitivo`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            },
            body: JSON.stringify({
                idSolicitante: idResponsable,
                anio,
                valeDefinitivo,
                idProyecto: proyecto.id,
                claveProyecto: proyecto.clave,
                descripcionProyecto: proyecto.descripcion,
                partida,
                idEntidad: sessionStorage.getItem('idEntidad'),
                seEnviaCorreo
            })
        })
        /*console.log(`${JSON.stringify({
            idSolicitante: idResponsable,
            anio,
            valeDefinitivo,
            idProyecto: proyecto.id,
            claveProyecto: proyecto.clave,
            descripcionProyecto: proyecto.descripcion,
            partida
        })}`)*/
        const data = await res.json()
        if (res.status === 200) {
            if (props.matricula) {
                const resMonitor = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT_MONITORES}/comite/almacenarFolioMontoInforme`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": sessionStorage.getItem('token'),
                        "perfil": sessionStorage.getItem('perfil')
                    },
                    body: JSON.stringify({ idInforme, idVale: data.idVale })
                })

                const dataMonitor = await resMonitor.json()
                if (res.status === 200) {
                    setMensaje(dataMonitor.message)
                }
            }

            ///if(params.matricula)guardar folio y monto en el informe de monitores
            setProyecto(null)
            setPartidasProyecto([])
            setPartida(null)
            setValeDefinitivo({
                monto: null, documentos: new FormData(), rutaOficio: null, rutaReporte: null, idEmpleado: null,
                idAlumno: null, beneficiario: { id: null }, idPartidaProyecto: null,
                idSolicitud: null, observaciones: null, justificacion: null
            })
            setHelperTextBeneficiario('')
            setSeverity('success')
            setIdSolicitud(data.solicitud.id)

        }
        else
            setSeverity('error')
        if (data.message) {
            setOpenMensaje(true)
            setMensaje(mensaje + data.message)
            setLoading(false)
            return
        }
        else {
            setOpenMensaje(true)
            setMensaje("Se registró la solicitud.")
            setLoading(false)
        }
    }
    return (
        <>
            <form onSubmit={idSolicitud ? handleUpdate : handleSubmit}>
                <Grid container justifyContent='stretch' spacing={5} style={{ marginTop: 5 }}>
                    <Grid item xs={12} sm={6}>
                        <Autocomplete
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                            getOptionLabel={(option) => option.clave + '-' + option.descripcion}
                            value={proyecto ? proyecto : null}
                            onChange={async (event, newValue) => {
                                //await handleCarga()
                                //console.log(newValue)
                                setProyecto(newValue)
                                setPartida(null)
                                if (newValue) {
                                    const res2 = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/partidasProyecto/proyecto/${newValue.id}`, {
                                        method: "GET",
                                        headers: {
                                            "Content-Type": "application/json",
                                            "x-access-token": sessionStorage.getItem('token'),
                                            "perfil": sessionStorage.getItem('perfil')
                                        }
                                    })
                                    const partidasProyectoLectura = await res2.json()
                                    const partidasValeDefinitivos = partidasProyectoLectura.filter(partidasProyectoLectura => Number(partidasProyectoLectura.clave) < 5000000 || Number(partidasProyectoLectura.clave) > 5999999)
                                    //console.log(`partidasProyectoLectura ${JSON.stringify(partidasProyectoLectura)}`)

                                    //setPartidasProyecto(partidasValeDefinitivos)
                                    //Mostrar sólo las no 5000
                                    //console.log(`transferenciasDestino.clave ${JSON.stringify(transferenciasDestino[0].partida.clave)}`)


                                    if (partidasValeDefinitivos && partidasValeDefinitivos.length > 0) {
                                        setErrorProyectoSinPartidas(false)
                                        setHelperTextProyectoSinPartidas('')
                                        setPartidasProyecto(partidasValeDefinitivos)
                                    }
                                    else {
                                        setErrorProyectoSinPartidas(true)
                                        setHelperTextProyectoSinPartidas('Este proyecto no tiene partidas')
                                        setPartidasProyecto([])
                                    }
                                }

                            }}
                            id="proyecto"
                            name="proyecto"
                            options={proyectos}
                            sx={{ width: '100%' }}
                            renderInput={(params) => <TextField {...params} label={`Proyecto`} focused helperText={helperTextProyectoSinPartidas} error={errorProyectoSinPartidas} required multiline />}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        {partidasProyecto ? partidasProyecto.length > 0 ?
                            <Autocomplete
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                getOptionLabel={(option) => option.clave + '-' + option.concepto}
                                value={partida ? partida : null}
                                onChange={async (event, newValue) => {
                                    //console.log(`newValue ${JSON.stringify(newValue)}`)
                                    setPartida(newValue)
                                    setValeDefinitivo({ ...valeDefinitivo, idPartidaProyecto: newValue.idPartidaProyecto })
                                }}
                                id="partida"
                                name="partida"
                                options={partidasProyecto}
                                sx={{ width: '100%' }}
                                renderInput={(params) => <TextField {...params} label={`Partida`} focused required multiline />}
                            />
                            : <></> : <></>}

                    </Grid>

                    {partida ? <>
                        <Grid item xs={12} sm={6}>
                            <TextField name='idBeneficiario' label="Matrícula o número económico del beneficiario" required focused onChange={async (e) => {

                                const id = e.target.value

                                setIdBeneficiario(id)
                                //console.log(`id length ${id.length}`)

                                const resEmpleado = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/usuarios/${id}`)
                                let beneficiario = null

                                if (resEmpleado.status === 404) {
                                    const resAlumno = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/alumnos/${id}`)
                                    if (resAlumno.status === 404) {
                                        setErrorBeneficiario(true)
                                        setHelperTextBeneficiario('No hay ninguna persona registrada como Alumnado o Personal con esa matrícula o número económico')
                                        return
                                    }
                                    else {
                                        beneficiario = await resAlumno.json()
                                        valeDefinitivo.idAlumno = beneficiario.id
                                        setErrorBeneficiario(false)
                                        setHelperTextBeneficiario(beneficiario.nombreCompleto)
                                    }
                                }
                                else {
                                    beneficiario = await resEmpleado.json()
                                    valeDefinitivo.idEmpleado = beneficiario.id
                                    setErrorBeneficiario(false)
                                    setHelperTextBeneficiario(beneficiario.nombreCompleto)
                                }
                                valeDefinitivo.beneficiario = { ...beneficiario }


                            }} value={idBeneficiario} helperText={helperTextBeneficiario} error={errorBeneficiario} sx={{ width: '100%' }} />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField name='monto' label="Monto" required onChange={(e) => {
                                const valor = e.target.value
                                const valorNumerico = Math.abs(valor.replace(/,/g, ''))
                                const fechaPrioridad2 = new Date(fechas.activarMontosPrioridad2)
                                fechaPrioridad2.setDate(fechaPrioridad2.getDate() + 1);
                                let montoDisponible = Number(partida.prioridad1Disponible)
                                if (Date.now() >= Date.parse(fechaPrioridad2)) {
                                    montoDisponible += Number(partida.prioridad2Disponible)
                                }
                                //console.log(`fecha prioridad 2 ${fechaPrioridad2}`)
                                setValeDefinitivo({ ...valeDefinitivo, 'monto': valorNumerico })

                                if (verificarDisponible() && Number(valorNumerico) > Number((Number(montoDisponible) + Number(montoComprometido)).toFixed(2))) {
                                    setErrorMonto(true)
                                    setHelperTextMonto(`No debe exceder el monto disponible de la partida ${format({ prefix: '$' })(Number((Number(montoDisponible) + Number(montoComprometido)).toFixed(2)))}. Puede solicitar una transferencia a esta partida si así lo requiere.`)
                                }
                                else {
                                    setErrorMonto(false)
                                    setHelperTextMonto('')
                                }
                                //console.log(`ErrorMonto ${errorMonto} valor ${valorNumerico} partida.montoDisponible ${montoDisponible}`)
                            }} InputProps={{
                                inputComponent: NumberFormatMoney,
                                startAdornment: (
                                    <InputAdornment position="start">
                                        $
                                    </InputAdornment>
                                ),
                            }} value={valeDefinitivo.monto} helperText={helperTextMonto} error={errorMonto} sx={{ width: '100%' }} />
                        </Grid>


                        <Grid item xs={12}>
                            <TextField label={'Oficio PDF'} id='documentoOficio' name='documentoOficio' focused
                                required={!idSolicitud && !idOficio} disabled={idInforme} type='file' accept="application/pdf" helperText={helperTextOficio} error={errorOficio} ref={fileOficio} onChange={async (event) => {
                                    if (valeDefinitivo.documentos)
                                        valeDefinitivo.documentos.delete('oficio')
                                    const file = event.target.files[0]
                                    if (event.target.value) {
                                        /*let regex = /([^-\w.]*)/gm;
                                        const nombreArchivo = file.name.replace(regex, '');
                                        const resVerificar = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/servicios/verificarDocumento`, {
                                            method: "GET",
                                            headers: {
                                                "nombre": nombreArchivo
                                            }
                                        })
                                        if (resVerificar.status === 200) {
                                            //setErrorDocumentoPDF(true)
                                            //setHelperTextDocumentoPDF('Ya existe un archivo registrado con ese nombre, por favor renómbralo')
                                            setErrorReporte(false)
                                            const data = await resVerificar.json()
                                            setValeDefinitivo({ ...valeDefinitivo, rutaOficio: data.ruta })
                                            setRutaOficio(true)
                                            setHelperTextOficio('Ya existe un archivo registrado con ese nombre. Si no lo subiste tú en un intento anterior por favor renombra tu archivo y trata de subirlo de nuevo, de lo contrario se colocará el enlace al archivo existente')
    
                                            return
                                        }
    
                                        else {
                                            setRutaOficio(false)
                                            setErrorOficio(false)
                                            setHelperTextOficio('')
                                        }*/

                                        if (event.target.value.endsWith(".PDF") || event.target.value.endsWith(".pdf")) {
                                            setHelperTextOficio('')
                                            setErrorOficio(false)
                                        }
                                        else {
                                            setHelperTextOficio('Formato de archivo no válido, se requiere PDF')
                                            setErrorOficio(true)
                                            return
                                        }
                                        if (file.size > 5242880) {
                                            setHelperTextOficio('El tamaño del archivo debe ser menor a 5MB')
                                            setErrorOficio(true)
                                            return
                                        }
                                        else {
                                            setHelperTextOficio('')
                                            setErrorOficio(false)
                                        }
                                        //console.log(`event.target.value.match(/[A-Za-z0-9_-]/gi) ${event.target.files[0].name.match(/[A-Za-z0-9_-]/gi)} ${event.target.files[0].name.match(/[A-Za-z0-9_-]/gi).length} cadena ${event.target.files[0].name.length}`)
                                        // Si la longitud coincide significa que sólo se encontraron letras, números y guiones
                                        /*if (file.name.match(/[A-Za-z0-9_-]/gi).length === file.name.length - 1) //Se resta uno por el punto de la extensión
                                        {
                                            setHelperTextOficio('')
                                            setErrorOficio(false)
                                        }
                                        
                                        else {
                                            setHelperTextOficio('El nombre del archivo no debe contener caracteres especiales como acentos o espacios en blanco, puede separar palabras con - o _')
                                            setErrorOficio(true)
                                            return
                                        }*/
                                        setHelperTextOficio('')
                                        setErrorOficio(false)
                                    }
                                    //console.log(`Files[0] ${file.name}`)
                                    valeDefinitivo.documentos.append('oficio', file)
                                }} sx={{ width: '100%' }} />
                            {valeDefinitivo.rutaOficio ?
                                <Link style={{ cursor: 'pointer' }} onClick={async () => { await mostrarDocumento(valeDefinitivo.rutaOficio, 'pdf') }} target='_blank'>{colocarNombre(valeDefinitivo.rutaOficio)}<PreviewTwoToneIcon></PreviewTwoToneIcon></Link> :
                                <></>
                            }
                        </Grid>

                        <Grid item xs={12}>
                            <TextField label='Reporte de actividades PDF' id='documentoReporte' name='documentoReporte' focused required={!idSolicitud && !idInforme} type='file' disabled={idInforme}
                                accept="application/pdf" helperText={helperReporte} error={errorReporte} ref={fileReporte} onChange={async (event) => {
                                    if (valeDefinitivo.documentos)
                                        valeDefinitivo.documentos.delete('reporte')
                                    const file = event.target.files[0]
                                    if (event.target.value) {
                                        /*let regex = /([^-\w.]*)/gm;
                                        const nombreArchivo = file.name.replace(regex, '');
                                        const resVerificar = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/servicios/verificarDocumento`, {
                                            method: "GET",
                                            headers: {
                                                "nombre": nombreArchivo
                                            }
                                        })
                                        if (resVerificar.status === 200) {
                                            setErrorReporte(false)
                                            //setErrorDocumentoPDF(true)
                                            //setHelperTextDocumentoPDF('Ya existe un archivo registrado con ese nombre, por favor renómbralo')
                                            const data = await resVerificar.json()
                                            setValeDefinitivo({ ...valeDefinitivo, rutaReporte: data.ruta })
                                            setRutaReporte(true)
                                            setHelperReporte('Ya existe un archivo registrado con ese nombre. Si no lo subiste tú en un intento anterior por favor renombra tu archivo y trata de subirlo de nuevo, de lo contrario se colocará el enlace al archivo existente')
    
                                            return
                                        }
    
                                        else {
                                            setRutaReporte(false)
                                            setErrorReporte(false)
                                            setHelperReporte('')
                                        }   */
                                        if (event.target.value.endsWith(".PDF") || event.target.value.endsWith(".pdf")) {
                                            setHelperReporte('')
                                            setErrorReporte(false)
                                        }
                                        else {
                                            setHelperReporte('Formato de archivo no válido, se requiere PDF')
                                            setErrorReporte(true)
                                            return
                                        }
                                        if (file.size > 5242880) {
                                            setHelperReporte('El tamaño del archivo debe ser menor a 5MB')
                                            setErrorReporte(true)
                                            return
                                        }
                                        else {
                                            setHelperReporte('')
                                            setErrorReporte(false)
                                        }
                                        //console.log(`event.target.value.match(/[A-Za-z0-9_-]/gi) ${event.target.files[0].name.match(/[A-Za-z0-9_-]/gi)} ${event.target.files[0].name.match(/[A-Za-z0-9_-]/gi).length} cadena ${event.target.files[0].name.length}`)
                                        // Si la longitud coincide significa que sólo se encontraron letras, números y guiones
                                        /*if (file.name.match(/[A-Za-z0-9_-]/gi).length === file.name.length - 1) //Se resta uno por el punto de la extensión
                                        {
                                            setHelperReporte('')
                                            setErrorReporte(false)
                                        }
                                        
                                        else {
                                            setHelperReporte('El nombre del archivo no debe contener caracteres especiales como acentos o espacios en blanco, puede separar palabras con - o _')
                                            setErrorReporte(true)
                                            return
                                        }*/
                                        setHelperReporte('')
                                        setErrorReporte(false)
                                    }
                                    //console.log(`Files[0] ${file.name}`)
                                    valeDefinitivo.documentos.append('reporte', file)
                                }} sx={{ width: '100%' }} />
                            {valeDefinitivo.rutaReporte ?
                                <Link style={{ cursor: 'pointer' }} onClick={async () => { await mostrarDocumento(valeDefinitivo.rutaReporte, 'pdf') }} target='_blank'>{colocarNombre(valeDefinitivo.rutaReporte)}<PreviewTwoToneIcon></PreviewTwoToneIcon></Link> :
                                <></>
                            }
                        </Grid>

                        <Grid item xs={12} sm={12}>
                            <TextField label={`Observaciones`} id='observaciones' name='observaciones' focused multiline maxRows={5} sx={{ width: '100%' }}
                                onChange={(e) => {
                                    const valor = e.target.value
                                    setValeDefinitivo({ ...valeDefinitivo, [e.target.name]: valor })
                                }
                                } value={valeDefinitivo.observaciones} />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <TextField label={`Justificación`} id='justificacion' name='justificacion' focused multiline maxRows={5} sx={{ width: '100%' }}
                                onChange={(e) => {
                                    const valor = e.target.value
                                    setValeDefinitivo({ ...valeDefinitivo, [e.target.name]: valor })
                                }
                                } value={valeDefinitivo.justificacion} />
                        </Grid>  </>
                        : <></>}

                </Grid>

                {partida ?
                    <Grid item sx={{ marginTop: 5 }}>
                        <Button variant='contained' color='primary' type='submit' disabled={errorMonto || errorProyectoSinPartidas || sinConfiguracionFechas || loading}>
                            {idSolicitud ? 'Actualizar' : 'Solicitar'}
                        </Button>
                    </Grid> : <></>
                }
            </form>
            <Box sx={{ width: '100%' }}>
                <Collapse in={openMensaje}>
                    <Alert severity={severity}
                        action={
                            <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                    setOpenMensaje(false);
                                }}
                            >
                                <CloseIcon fontSize="inherit" />
                            </IconButton>
                        }
                        style={{ marginTop: 30 }}
                    >
                        {mensaje}
                    </Alert>
                </Collapse>
            </Box>
        </>
    )
}